var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"mb-6"},[_vm._v("Info & Help")]),_c('div',{staticClass:"white-space__pre-wrap"},[_vm._v(_vm._s(_vm.helpText))])])}
var staticRenderFns = []

export { render, staticRenderFns }